import { c as _c } from "react/compiler-runtime";
import { BreadcrumbsData, Hint, NeutralButton, PrimaryButton, toast } from '@systemeio/ui';
import { BadRequest, PayloadTooLarge } from '@systemeio/util';
import { SaveAndSendNewsletterModal } from 'modules/newsletters/single/components/save-and-send-newsletter-modal';
import { ScheduleNewsletterModal } from 'modules/newsletters/single/components/schedule-newsletter-modal';
import { newsletterDefaultErrors } from 'modules/newsletters/single/constants/newsletter-default-errors';
import { useGetNewsletterView } from 'modules/newsletters/single/hooks/use-get-newsletter-view';
import { useNewsletterContactsSettings } from 'modules/newsletters/single/hooks/use-newsletter-contacts-settings';
import { useUpdateNewsletter } from 'modules/newsletters/single/hooks/use-update-newsletter';
import { NewsletterId } from 'modules/newsletters/single/types/newsletter-interface';
import { NewsletterSplitTestViewApiInterface } from 'modules/newsletters/single/types/newsletter-view-interface';
import { getNewslettersListNextjsUrl } from 'modules/newsletters/single/utils/get-newsletters-list-nextjs-url';
import { setNewsletterEmailErrors } from 'modules/newsletters/single/utils/set-newsletter-email-errors';
import { CancelSplitTestModal } from 'modules/newsletters/split-test/components/cancel-split-test-modal';
import { InterruptSplitTestWithButton } from 'modules/newsletters/split-test/components/interrupt-split-test';
import { SaveAndTestSplitTest } from 'modules/newsletters/split-test/components/save-and-test-split-test';
import { SplitTestEditorBlock } from 'modules/newsletters/split-test/components/split-test-editor-block';
import { SplitTestSettings } from 'modules/newsletters/split-test/components/split-test-settings';
import { VariantsTabs } from 'modules/newsletters/split-test/components/variants-tabs';
import { defaultNewsletterSplitTestSettingsErrors } from 'modules/newsletters/split-test/constants/default-settings-errors';
import { MailingSplitTestStatusTypeEnum } from 'modules/newsletters/split-test/enum/mailing-split-test-status-type-enum';
import { useSplitTestSettings } from 'modules/newsletters/split-test/hooks/use-split-test-seetings';
import { useUpdateNewsletterSplitTestSettings } from 'modules/newsletters/split-test/hooks/use-update-newsletter-split-test-settings';
import { NewsletterSplitTestErrorResponseContentInterface } from 'modules/newsletters/split-test/types/newsletter-split-test-interface';
import { getSplitTestNewsletterStatisticsUrl } from 'modules/newsletters/split-test/utils/get-split-test-newsletter-statistics-url';
import { transformToNewsletterWithSplitTestData } from 'modules/newsletters/split-test/utils/transform-to-newsletter-with-split-test-data';
import { useTagsAll } from 'modules/tags/hooks/use-tags-all';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import BreadcrumbsDashboard from 'shared/components/breadcrumbs';
import { ButtonWithDropdown } from 'shared/components/buttin-with-dropdown/button-with-dropdown';
import { ButtonWithDropdownTypeEnum } from 'shared/components/buttin-with-dropdown/enums/button-with-dropdown-type-enum';
import AttachmentsBlock from 'shared/components/dashboard-mail-editor/components/attachments-block';
import ContactsSettingsBlock from 'shared/components/dashboard-mail-editor/components/contacts-settings-block';
import EmailSettingsBlock from 'shared/components/dashboard-mail-editor/components/email-settings-block';
import SubstitutesBlock from 'shared/components/dashboard-mail-editor/components/substitutes-block';
import { useMailingState } from 'shared/components/dashboard-mail-editor/hooks/use-mailing-state';
import { useUnsavedEmail } from 'shared/components/dashboard-mail-editor/hooks/use-unsaved-email';
import { getMailingUpdateData } from 'shared/components/dashboard-mail-editor/utils/get-mailing-update-data';
import { validateEmailBeforeSave } from 'shared/components/dashboard-mail-editor/utils/validate-email-before-save';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { ConfirmationModalBeforeExit } from 'shared/confirmation-modal-before-exit/component';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { deepCompare } from 'shared/utils/deepCompare';
import { CloseIcon, EventIcon, SendEmailIcon, StatisticsIcon, TestTubeIcon } from '@systemeio/ui/icons';
interface NewsletterSplitTestProps {
  newsletterId: NewsletterId;
  newsletterWithSplitTest: NewsletterSplitTestViewApiInterface;
}
export const NewsletterSplitTest = t0 => {
  const $ = _c(153);
  const {
    newsletterId,
    newsletterWithSplitTest
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    isRestrictedUser
  } = useUser();
  const router = useRouter();
  const [isFetching, setIsFetching] = useState(false);
  const selectedVariantId = router.query.variant ? Number(router.query.variant) : newsletterWithSplitTest.mailingSplitTest.mailingVariantA.id;
  const variantA = useMailingState({
    mailing: newsletterWithSplitTest.mailingSplitTest.mailingVariantA,
    onSave: data => onSave({
      variantA: {
        ...variantA,
        tempState: data
      },
      variantB,
      options: {
        throwError: true
      }
    }),
    defaultErrors: newsletterDefaultErrors
  });
  const variantB = useMailingState({
    mailing: newsletterWithSplitTest.mailingSplitTest.mailingVariantB,
    onSave: data_0 => onSave({
      variantA,
      variantB: {
        ...variantB,
        tempState: data_0
      },
      options: {
        throwError: true
      }
    }),
    defaultErrors: newsletterDefaultErrors
  });
  const isLoading = isFetching || variantA.isFetchingChooseEmailTemplate || variantB.isFetchingChooseEmailTemplate;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [commonErrors, setCommonErrors] = useState(t1);
  const [settingsErrors, setSettingsErrors] = useState(defaultNewsletterSplitTestSettingsErrors);
  const selectedVariant = selectedVariantId === variantA.mailing.id ? variantA : variantB;
  const {
    contactsSettings,
    setContactsSettings
  } = useNewsletterContactsSettings(newsletterWithSplitTest);
  const {
    splitTestSettings,
    setSplitTestSettings
  } = useSplitTestSettings(newsletterWithSplitTest);
  let t2;
  if ($[1] !== newsletterId) {
    t2 = {
      newsletterId
    };
    $[1] = newsletterId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    mutateNewslettersData
  } = useGetNewsletterView(t2);
  const {
    fetcherUpdateNewsletter
  } = useUpdateNewsletter(newsletterId);
  const {
    fetcherUpdateNewsletterSplitTestSettings
  } = useUpdateNewsletterSplitTestSettings(newsletterId);
  let t3;
  if ($[3] !== t) {
    t3 = t("dashboard.newsletter.newsletters");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = getNewslettersListNextjsUrl();
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3) {
    t5 = {
      caption: t3,
      href: t4,
      isStatic: true
    };
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t) {
    t6 = t("dashboard.newsletter.split_test.title");
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = {
      caption: t6,
      isStatic: true
    };
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t5 || $[13] !== t7) {
    t8 = [t5, t7];
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const breadcrumbsData = t8;
  const t9 = variantA;
  const t10 = data_1 => variantA.setTempState(prev => ({
    ...prev,
    body: data_1
  }));
  let t11;
  if ($[15] !== newsletterWithSplitTest.mailingSplitTest.mailingVariantA.currentEmail.body || $[16] !== newsletterWithSplitTest.mailingSplitTest.mailingVariantA.id || $[17] !== t10 || $[18] !== t9.tempState.body) {
    t11 = {
      mailingId: newsletterWithSplitTest.mailingSplitTest.mailingVariantA.id,
      currentBody: t9.tempState.body,
      initialBody: newsletterWithSplitTest.mailingSplitTest.mailingVariantA.currentEmail.body,
      showImmediately: true,
      onPaste: t10
    };
    $[15] = newsletterWithSplitTest.mailingSplitTest.mailingVariantA.currentEmail.body;
    $[16] = newsletterWithSplitTest.mailingSplitTest.mailingVariantA.id;
    $[17] = t10;
    $[18] = t9.tempState.body;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const unsavedDataVariantA = useUnsavedEmail(t11);
  const t12 = variantB;
  const t13 = data_2 => variantB.setTempState(prev_0 => ({
    ...prev_0,
    body: data_2
  }));
  let t14;
  if ($[20] !== newsletterWithSplitTest.mailingSplitTest.mailingVariantB.currentEmail.body || $[21] !== newsletterWithSplitTest.mailingSplitTest.mailingVariantB.id || $[22] !== t12.tempState.body || $[23] !== t13) {
    t14 = {
      mailingId: newsletterWithSplitTest.mailingSplitTest.mailingVariantB.id,
      currentBody: t12.tempState.body,
      initialBody: newsletterWithSplitTest.mailingSplitTest.mailingVariantB.currentEmail.body,
      showImmediately: true,
      onPaste: t13
    };
    $[20] = newsletterWithSplitTest.mailingSplitTest.mailingVariantB.currentEmail.body;
    $[21] = newsletterWithSplitTest.mailingSplitTest.mailingVariantB.id;
    $[22] = t12.tempState.body;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  const unsavedDataVariantB = useUnsavedEmail(t14);
  const {
    tags: listOfTags
  } = useTagsAll();
  const [isDataSaved, setIsDataSaved] = useState(true);
  const t15 = variantA;
  const t16 = variantB;
  let t17;
  if ($[25] !== contactsSettings || $[26] !== listOfTags || $[27] !== newsletterWithSplitTest || $[28] !== splitTestSettings || $[29] !== t15 || $[30] !== t16) {
    t17 = [contactsSettings, listOfTags, newsletterWithSplitTest, splitTestSettings, t15, t16];
    $[25] = contactsSettings;
    $[26] = listOfTags;
    $[27] = newsletterWithSplitTest;
    $[28] = splitTestSettings;
    $[29] = t15;
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  useEffect(() => {
    setIsDataSaved(deepCompare(transformToNewsletterWithSplitTestData({
      listOfTags,
      variantA,
      variantB,
      contactsSettings,
      newsletterData: newsletterWithSplitTest,
      splitTestSettings,
      attachmentsTempStateVariantA: variantA.attachmentsTempState,
      attachmentsTempStateVariantB: variantB.attachmentsTempState
    }), newsletterWithSplitTest));
  }, t17);
  const onSave = async t18 => {
    const {
      variantA: variantA_0,
      variantB: variantB_0,
      options
    } = t18;
    ;
    try {
      variantA_0.setDefaultErrors();
      variantB_0.setDefaultErrors();
      setCommonErrors([]);
      setSettingsErrors(defaultNewsletterSplitTestSettingsErrors);
      validateEmailBeforeSave(variantA_0.tempState.fromEmail, variantA_0.setErrors, t);
      validateEmailBeforeSave(variantB_0.tempState.fromEmail, variantB_0.setErrors, t);
      setIsFetching(true);
      const [, newsletterSplitTestResponseData] = await Promise.all([fetcherUpdateNewsletter({
        tags: contactsSettings.tags.included,
        excludedTags: contactsSettings.tags.excluded,
        daysExists: contactsSettings.daysExists
      }), fetcherUpdateNewsletterSplitTestSettings({
        settings: splitTestSettings,
        mailingVariantA: {
          currentEmail: getMailingUpdateData(variantA_0.tempState, variantA_0.attachmentsTempState)
        },
        mailingVariantB: {
          currentEmail: getMailingUpdateData(variantB_0.tempState, variantB_0.attachmentsTempState)
        }
      })]);
      await mutateNewslettersData(() => transformToNewsletterWithSplitTestData({
        listOfTags,
        newsletterData: newsletterWithSplitTest,
        splitTestSettings,
        variantA: variantA_0,
        variantB: variantB_0,
        contactsSettings,
        attachmentsTempStateVariantA: newsletterSplitTestResponseData.mailingVariantA.currentEmail.attachments,
        attachmentsTempStateVariantB: newsletterSplitTestResponseData.mailingVariantB.currentEmail.attachments
      }), false);
      toast.success(t("global.changes_saved"));
      setIsFetching(false);
      await unsavedDataVariantA.removeDbRecord();
      await unsavedDataVariantB.removeDbRecord();
    } catch (t19) {
      const e = t19;
      setIsFetching(false);
      toast.error(t("global.error"));
      if (e instanceof BadRequest) {
        const errors = e.errors as NewsletterSplitTestErrorResponseContentInterface;
        if (errors.fields) {
          const {
            settings,
            mailingVariantA,
            mailingVariantB
          } = errors.fields;
          if (settings) {
            setSettingsErrors(settings);
          }
          if (mailingVariantA) {
            setNewsletterEmailErrors(variantA_0.setErrors, mailingVariantA.currentEmail);
          }
          if (mailingVariantB) {
            setNewsletterEmailErrors(variantB_0.setErrors, mailingVariantB.currentEmail);
          }
        }
        if (e.errors.common) {
          const commonErrors_0 = e.errors.common;
          setCommonErrors(commonErrors_0);
        }
      } else {
        if (e instanceof PayloadTooLarge) {
          toast.error(t("core.error.payload_to_large_error_message"));
        }
      }
      if (options?.throwError) {
        throw e;
      }
    }
  };
  const isTagsSelected = !!contactsSettings.tags.included.length;
  const isRunning = newsletterWithSplitTest.mailingSplitTest.status === MailingSplitTestStatusTypeEnum.Running;
  let t20;
  if ($[32] !== mutateNewslettersData) {
    t20 = async () => {
      await mutateNewslettersData(_temp, false);
    };
    $[32] = mutateNewslettersData;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  const interruptSplitTest = t20;
  let t21;
  if ($[34] !== breadcrumbsData) {
    t21 = <BreadcrumbsDashboard data={breadcrumbsData} />;
    $[34] = breadcrumbsData;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  let t22;
  if ($[36] !== interruptSplitTest || $[37] !== isFetching || $[38] !== isLoading || $[39] !== isRestrictedUser || $[40] !== isRunning || $[41] !== isTagsSelected || $[42] !== mutateNewslettersData || $[43] !== newsletterId || $[44] !== newsletterWithSplitTest.mailingSplitTest || $[45] !== newsletterWithSplitTest.scheduledAt || $[46] !== newsletterWithSplitTest.sent || $[47] !== onSave || $[48] !== t || $[49] !== variantA || $[50] !== variantB) {
    t22 = newsletterWithSplitTest?.sent ? <div className="flex gap-5">{isRunning && <InterruptSplitTestWithButton mailingSplitTestId={newsletterWithSplitTest.mailingSplitTest.id} afterAbandon={interruptSplitTest} />}<PrimaryButton as={LinkWithoutPrefetch} aria-disabled={isLoading} href={getSplitTestNewsletterStatisticsUrl(newsletterId)}><StatisticsIcon className="h-[20px] w-[20px]" /><span className="hidden lg:flex">{t("dashboard.newsletter_editor.statistics")}</span></PrimaryButton></div> : <><CancelSplitTestModal newsletterId={newsletterId} mailingSplitTest={newsletterWithSplitTest.mailingSplitTest} /><ButtonWithDropdown options={[{
        name: "save-and-test-variant",
        menuItem: {
          title: t("dashboard.newsletter_editor.save_and_test"),
          icon: <TestTubeIcon className="fill-text-primary h-[18px] w-[18px]" />,
          disabled: !!isRestrictedUser
        },
        type: ButtonWithDropdownTypeEnum.Button,
        onActionRender: (opened, onClose, key) => <SaveAndTestSplitTest onSave={() => onSave({
          variantA,
          variantB,
          options: {
            throwError: true
          }
        })} opened={opened} onClose={onClose} key={key} variantA={variantA} variantB={variantB} />
      }, {
        name: "save-and-run-split-test",
        menuItem: {
          title: t("dashboard.newsletter_editor.split_test.save_and_run.title"),
          icon: <SendEmailIcon className="fill-text-primary h-[18px] w-[18px]" />,
          disabled: !!isRestrictedUser
        },
        type: ButtonWithDropdownTypeEnum.Button,
        onActionRender: (opened_0, onClose_0, key_0) => <SaveAndSendNewsletterModal opened={opened_0} onClose={onClose_0} key={key_0} newsletterId={newsletterId} onSave={() => onSave({
          variantA,
          variantB,
          options: {
            throwError: true
          }
        })} confirmationText={t("dashboard.newsletter_editor.split_test.save_and_run.description")} isTagsSelected={isTagsSelected} />
      }, {
        name: "schedule-split-test",
        menuItem: {
          title: t("dashboard.newsletter_editor.save_and_schedule"),
          icon: <EventIcon className="fill-text-primary h-[18px] w-[18px]" />,
          disabled: !!isRestrictedUser
        },
        type: ButtonWithDropdownTypeEnum.Button,
        onActionRender: (opened_1, onClose_1, key_1) => <ScheduleNewsletterModal title={t("dashboard.newsletter_editor.split_test.schedule_split_test")} opened={opened_1} isTagsSelected={isTagsSelected} onClose={onClose_1} key={key_1} scheduledAt={newsletterWithSplitTest.scheduledAt} newsletterId={newsletterId} onSave={() => onSave({
          variantA,
          variantB,
          options: {
            throwError: true
          }
        })} mutateNewslettersData={mutateNewslettersData} />
      }]} disabled={isLoading} onClick={() => onSave({
        variantA,
        variantB
      })} title={t("global.save_draft")} isFetching={isFetching} /></>;
    $[36] = interruptSplitTest;
    $[37] = isFetching;
    $[38] = isLoading;
    $[39] = isRestrictedUser;
    $[40] = isRunning;
    $[41] = isTagsSelected;
    $[42] = mutateNewslettersData;
    $[43] = newsletterId;
    $[44] = newsletterWithSplitTest.mailingSplitTest;
    $[45] = newsletterWithSplitTest.scheduledAt;
    $[46] = newsletterWithSplitTest.sent;
    $[47] = onSave;
    $[48] = t;
    $[49] = variantA;
    $[50] = variantB;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  let t24;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = getNewslettersListNextjsUrl();
    t24 = <CloseIcon className="h-[20px] w-[20px]" />;
    $[52] = t23;
    $[53] = t24;
  } else {
    t23 = $[52];
    t24 = $[53];
  }
  let t25;
  if ($[54] !== t) {
    t25 = t("global.exit");
    $[54] = t;
    $[55] = t25;
  } else {
    t25 = $[55];
  }
  let t26;
  if ($[56] !== t25) {
    t26 = <NeutralButton as={LinkWithoutPrefetch} href={t23}>{t24}<span className="hidden lg:flex">{t25}</span></NeutralButton>;
    $[56] = t25;
    $[57] = t26;
  } else {
    t26 = $[57];
  }
  let t27;
  if ($[58] !== t22 || $[59] !== t26) {
    t27 = <div className="flex gap-3">{t22}{t26}</div>;
    $[58] = t22;
    $[59] = t26;
    $[60] = t27;
  } else {
    t27 = $[60];
  }
  let t28;
  if ($[61] !== t21 || $[62] !== t27) {
    t28 = <div className="flex flex-col items-center justify-between gap-5 sm:flex-row">{t21}{t27}</div>;
    $[61] = t21;
    $[62] = t27;
    $[63] = t28;
  } else {
    t28 = $[63];
  }
  let t29;
  if ($[64] !== commonErrors) {
    t29 = commonErrors.map(_temp2);
    $[64] = commonErrors;
    $[65] = t29;
  } else {
    t29 = $[65];
  }
  let t30;
  if ($[66] !== t) {
    t30 = t("dashboard.newsletter_editor.split_test.general_settings.description");
    $[66] = t;
    $[67] = t30;
  } else {
    t30 = $[67];
  }
  let t31;
  if ($[68] !== t) {
    t31 = t("dashboard.newsletter_editor.split_test.general_settings.title");
    $[68] = t;
    $[69] = t31;
  } else {
    t31 = $[69];
  }
  let t32;
  if ($[70] !== t31) {
    t32 = <b className="text-text-primary text-base">{t31}</b>;
    $[70] = t31;
    $[71] = t32;
  } else {
    t32 = $[71];
  }
  let t33;
  if ($[72] !== t30 || $[73] !== t32) {
    t33 = <Hint label={t30}>{t32}</Hint>;
    $[72] = t30;
    $[73] = t32;
    $[74] = t33;
  } else {
    t33 = $[74];
  }
  let t34;
  if ($[75] !== isLoading || $[76] !== newsletterWithSplitTest.sent || $[77] !== setSplitTestSettings || $[78] !== settingsErrors || $[79] !== splitTestSettings) {
    t34 = <SplitTestSettings disabled={newsletterWithSplitTest.sent} isPreFetching={isLoading} errors={settingsErrors} splitTestSettings={splitTestSettings} onChange={setSplitTestSettings} />;
    $[75] = isLoading;
    $[76] = newsletterWithSplitTest.sent;
    $[77] = setSplitTestSettings;
    $[78] = settingsErrors;
    $[79] = splitTestSettings;
    $[80] = t34;
  } else {
    t34 = $[80];
  }
  let t35;
  if ($[81] !== contactsSettings || $[82] !== isLoading || $[83] !== newsletterWithSplitTest.sent || $[84] !== setContactsSettings) {
    t35 = <ContactsSettingsBlock disabled={newsletterWithSplitTest.sent} isPreFetching={isLoading} contactsSettings={contactsSettings} onChangeContactsSettings={setContactsSettings} />;
    $[81] = contactsSettings;
    $[82] = isLoading;
    $[83] = newsletterWithSplitTest.sent;
    $[84] = setContactsSettings;
    $[85] = t35;
  } else {
    t35 = $[85];
  }
  let t36;
  if ($[86] !== newsletterWithSplitTest.mailingSplitTest || $[87] !== variantA.hasErrors || $[88] !== variantB.hasErrors) {
    t36 = <VariantsTabs variantAHasError={variantA.hasErrors} variantBHasError={variantB.hasErrors} splitTestData={newsletterWithSplitTest.mailingSplitTest} />;
    $[86] = newsletterWithSplitTest.mailingSplitTest;
    $[87] = variantA.hasErrors;
    $[88] = variantB.hasErrors;
    $[89] = t36;
  } else {
    t36 = $[89];
  }
  let t37;
  if ($[90] !== isLoading || $[91] !== newsletterWithSplitTest.sent || $[92] !== selectedVariantId || $[93] !== unsavedDataVariantA || $[94] !== unsavedDataVariantB || $[95] !== variantA || $[96] !== variantB) {
    t37 = <SplitTestEditorBlock variantA={variantA} variantB={variantB} unsavedDataVariantA={unsavedDataVariantA} unsavedDataVariantB={unsavedDataVariantB} isLoading={isLoading} disabled={newsletterWithSplitTest.sent} selectedVariantId={selectedVariantId} />;
    $[90] = isLoading;
    $[91] = newsletterWithSplitTest.sent;
    $[92] = selectedVariantId;
    $[93] = unsavedDataVariantA;
    $[94] = unsavedDataVariantB;
    $[95] = variantA;
    $[96] = variantB;
    $[97] = t37;
  } else {
    t37 = $[97];
  }
  let t38;
  if ($[98] !== t36 || $[99] !== t37) {
    t38 = <div>{t36}{t37}</div>;
    $[98] = t36;
    $[99] = t37;
    $[100] = t38;
  } else {
    t38 = $[100];
  }
  let t39;
  if ($[101] !== t33 || $[102] !== t34 || $[103] !== t35 || $[104] !== t38) {
    t39 = <div className="flex min-w-0 flex-col gap-5 lg:h-auto lg:basis-3/4">{t33}{t34}{t35}{t38}</div>;
    $[101] = t33;
    $[102] = t34;
    $[103] = t35;
    $[104] = t38;
    $[105] = t39;
  } else {
    t39 = $[105];
  }
  let t40;
  if ($[106] !== t) {
    t40 = t("dashboard.newsletter_editor.split_test.specific_settings.description");
    $[106] = t;
    $[107] = t40;
  } else {
    t40 = $[107];
  }
  let t41;
  if ($[108] !== t) {
    t41 = t("dashboard.newsletter_editor.split_test.specific_settings.title");
    $[108] = t;
    $[109] = t41;
  } else {
    t41 = $[109];
  }
  let t42;
  if ($[110] !== t41) {
    t42 = <b className="text-text-primary text-base">{t41}</b>;
    $[110] = t41;
    $[111] = t42;
  } else {
    t42 = $[111];
  }
  let t43;
  if ($[112] !== t40 || $[113] !== t42) {
    t43 = <Hint label={t40}>{t42}</Hint>;
    $[112] = t40;
    $[113] = t42;
    $[114] = t43;
  } else {
    t43 = $[114];
  }
  let t44;
  if ($[115] !== isLoading || $[116] !== newsletterWithSplitTest.sent || $[117] !== selectedVariant.errors || $[118] !== selectedVariant.onChangeEmail || $[119] !== selectedVariant.tempState) {
    t44 = <EmailSettingsBlock disabled={newsletterWithSplitTest.sent} isPreFetching={isLoading} tempState={selectedVariant.tempState} onChangeEmail={selectedVariant.onChangeEmail} errors={selectedVariant.errors} />;
    $[115] = isLoading;
    $[116] = newsletterWithSplitTest.sent;
    $[117] = selectedVariant.errors;
    $[118] = selectedVariant.onChangeEmail;
    $[119] = selectedVariant.tempState;
    $[120] = t44;
  } else {
    t44 = $[120];
  }
  const t45 = selectedVariant.errors?.attachments;
  let t46;
  if ($[121] !== isLoading || $[122] !== newsletterWithSplitTest.sent || $[123] !== selectedVariant.attachmentsTempState || $[124] !== selectedVariant.setAttachmentsTempState || $[125] !== t45) {
    t46 = <AttachmentsBlock disabled={newsletterWithSplitTest.sent} isPreFetching={isLoading} attachmentsTempState={selectedVariant.attachmentsTempState} setAttachmentsTempState={selectedVariant.setAttachmentsTempState} errors={t45} />;
    $[121] = isLoading;
    $[122] = newsletterWithSplitTest.sent;
    $[123] = selectedVariant.attachmentsTempState;
    $[124] = selectedVariant.setAttachmentsTempState;
    $[125] = t45;
    $[126] = t46;
  } else {
    t46 = $[126];
  }
  let t47;
  if ($[127] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = <SubstitutesBlock />;
    $[127] = t47;
  } else {
    t47 = $[127];
  }
  let t48;
  if ($[128] !== t43 || $[129] !== t44 || $[130] !== t46) {
    t48 = <div className="static top-5 flex h-fit flex-col gap-5 sm:min-w-[320px] lg:sticky lg:basis-1/4">{t43}{t44}{t46}{t47}</div>;
    $[128] = t43;
    $[129] = t44;
    $[130] = t46;
    $[131] = t48;
  } else {
    t48 = $[131];
  }
  let t49;
  if ($[132] !== t39 || $[133] !== t48) {
    t49 = <div className="flex flex-col gap-5 lg:flex-row">{t39}{t48}</div>;
    $[132] = t39;
    $[133] = t48;
    $[134] = t49;
  } else {
    t49 = $[134];
  }
  let t50;
  if ($[135] !== t29 || $[136] !== t49) {
    t50 = <div className="flex flex-col gap-3">{t29}{t49}</div>;
    $[135] = t29;
    $[136] = t49;
    $[137] = t50;
  } else {
    t50 = $[137];
  }
  let t51;
  if ($[138] !== t28 || $[139] !== t50) {
    t51 = <div className="flex flex-col gap-5">{t28}{t50}</div>;
    $[138] = t28;
    $[139] = t50;
    $[140] = t51;
  } else {
    t51 = $[140];
  }
  let t52;
  if ($[141] !== t) {
    t52 = t("dashboard.newsletter_editor.confirmation_message_before_exit");
    $[141] = t;
    $[142] = t52;
  } else {
    t52 = $[142];
  }
  const t53 = isDataSaved || newsletterWithSplitTest.sent;
  let t54;
  if ($[143] !== router.asPath || $[144] !== router.basePath) {
    t54 = route => {
      const newPath = route.split("?")[0];
      const existingPath = (router.basePath + router.asPath).split("?")[0];
      return newPath === existingPath;
    };
    $[143] = router.asPath;
    $[144] = router.basePath;
    $[145] = t54;
  } else {
    t54 = $[145];
  }
  let t55;
  if ($[146] !== t52 || $[147] !== t53 || $[148] !== t54) {
    t55 = <ConfirmationModalBeforeExit confirmationText={t52} hideModal={t53} shouldSkipOnRouteChange={t54} />;
    $[146] = t52;
    $[147] = t53;
    $[148] = t54;
    $[149] = t55;
  } else {
    t55 = $[149];
  }
  let t56;
  if ($[150] !== t51 || $[151] !== t55) {
    t56 = <>{t51}{t55}</>;
    $[150] = t51;
    $[151] = t55;
    $[152] = t56;
  } else {
    t56 = $[152];
  }
  return t56;
};
function _temp(data_3) {
  return data_3 && {
    ...data_3,
    mailingSplitTest: data_3.mailingSplitTest ? {
      ...data_3.mailingSplitTest,
      status: MailingSplitTestStatusTypeEnum.Interrupted
    } : null
  };
}
function _temp2(error, index) {
  return <p className="text-danger px-6 text-center text-sm" key={index}>{error}</p>;
}